import { useCallback, useEffect, useRef, useState } from 'react';
export const useThrottle = () => {
    const [throttled, setThrottled] = useState(false);
    const timeoutHandle = useRef(null);
    const throttle = useCallback((timeout) => {
        if (timeoutHandle.current) {
            window.clearTimeout(timeoutHandle.current);
            timeoutHandle.current = null;
        }
        else {
            setThrottled(true);
        }
        timeoutHandle.current = window.setTimeout(() => {
            timeoutHandle.current = null;
            setThrottled(false);
        }, timeout);
    }, []);
    useEffect(() => () => {
        if (timeoutHandle.current) {
            window.clearTimeout(timeoutHandle.current);
            timeoutHandle.current = null;
        }
    }, []);
    return [throttled, throttle];
};
//# sourceMappingURL=useThrottle.js.map